import React, { useState, useMemo, useEffect, useCallback } from 'react';
import InputMask from 'react-input-mask';
import { Icon } from '@sravni/react-design-system';
import { Cross, TailArrowRight } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { getMaskInputMode } from '../../utils/getMaskByInputMode.js';
import modules_72a695e8 from './styles/Scenario.module.less.js';
import { TextInput } from './TextInput.js';

function ScenarionInput({ onChange, value, inputMode, onKeyDown }) {
    const [currentMask, setCurrentMask] = useState();
    const { mask: inputMask, placeholder: inputPlaceholder } = useMemo(() => getMaskInputMode(inputMode), [inputMode]);
    const cx = useStyles(modules_72a695e8);
    useEffect(() => {
        if (inputMask && !Array.isArray(inputMask[0])) {
            setCurrentMask(inputMask);
        }
        if (!inputMask) {
            setCurrentMask(inputMask);
        }
    }, [inputMask]);
    const setInputValue = ({ target }) => {
        if (inputMode === 'default') {
            onChange(target?.value);
            return;
        }
        if ((target?.value.length === 0 || target?.value[0] === '_') && Array.isArray(inputMask?.[0])) {
            setCurrentMask(undefined);
            onChange('');
            return;
        }
        if (!(inputMask && Array.isArray(inputMask[0]) && !currentMask)) {
            onChange(target?.value);
            return;
        }
        const suitableMasks = inputMask.filter((mask) => {
            const stringMask = mask
                .slice(0, target?.value.length)
                .map((r) => (typeof r === 'string' ? r : r.source))
                .join('');
            const regExpMask = new RegExp(stringMask);
            const match = target.value.match(regExpMask);
            return Boolean(match) && target?.value.length <= mask.length;
        });
        if (suitableMasks.length > 0) {
            onChange(target?.value);
            if (suitableMasks.length === 1) {
                setCurrentMask(suitableMasks[0]);
            }
        }
    };
    const getInputIcon = useCallback(() => {
        if (value) {
            return React.createElement(Icon, { icon: React.createElement(Cross, null), onClick: () => onChange(''), className: cx(modules_72a695e8.crossIcon) });
        }
        return React.createElement(Icon, { icon: React.createElement(TailArrowRight, null), className: cx(modules_72a695e8.arrowIcon) });
    }, [value, cx, onChange]);
    return currentMask ? (React.createElement(InputMask, { mask: currentMask, placeholder: inputPlaceholder, value: value, onKeyDown: onKeyDown, onChange: setInputValue },
        React.createElement(TextInput, { icon: getInputIcon(), value: value, loading: false }))) : (React.createElement(InputMask, { placeholder: inputPlaceholder, value: value, onKeyDown: onKeyDown, onChange: setInputValue },
        React.createElement(TextInput, { icon: getInputIcon(), value: value, loading: false })));
}

export { ScenarionInput };
//# sourceMappingURL=ScenarioInput.js.map
